import { render } from "./index.vue?vue&type=template&id=6c94812b&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=6c94812b&lang=less"
import "./index.vue?vue&type=style&index=1&id=6c94812b&lang=less&scoped=true"

import exportComponent from "/Users/bld/web/doctor2/doctor-pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c94812b"]])

export default __exports__